import { c as _c } from "react/compiler-runtime";
import { IcoClose24, IcoPlusSmall16 } from '@onefootprint/icons';
import { Form, IconButton, LinkButton, type TemplateInputProps, TextInput } from '@onefootprint/ui';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAutoDataIdentifier } from '../../../hooks/use-auto-data-identifier';
import { asOptionsControl, type CustomQuestionsFormData } from '../../../types';
import DataIdentifierField from '../data-identifier-field';
type DropdownFormProps = {
  questionIndex: number;
  autocompleteItems?: TemplateInputProps['autocompleteItems'];
};
const DropdownForm = t0 => {
  const $ = _c(97);
  const {
    questionIndex,
    autocompleteItems
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  useAutoDataIdentifier(questionIndex);
  const {
    control,
    setValue
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = asOptionsControl(control);
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const optionsControl = t1;
  const t2 = `questions.${questionIndex}.options`;
  let t3;
  if ($[2] !== optionsControl || $[3] !== t2) {
    t3 = {
      control: optionsControl,
      name: t2
    };
    $[2] = optionsControl;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    fields,
    append,
    remove
  } = useFieldArray(t3);
  const t4 = `questions.${questionIndex}.includeOther`;
  let t5;
  if ($[5] !== optionsControl || $[6] !== t4) {
    t5 = {
      control: optionsControl,
      name: t4
    };
    $[5] = optionsControl;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const includeOther = useWatch(t5);
  let t6;
  if ($[8] !== fields.length || $[9] !== includeOther || $[10] !== remove) {
    t6 = index => {
      const minOptions = includeOther ? 1 : 2;
      if (fields.length > minOptions) {
        remove(index);
      }
    };
    $[8] = fields.length;
    $[9] = includeOther;
    $[10] = remove;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleRemoveOption = t6;
  const t7 = `questions.${questionIndex}.label`;
  let t8;
  if ($[12] !== t) {
    t8 = t(_temp);
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t(_temp2);
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== autocompleteItems) {
    t10 = autocompleteItems ?? {};
    $[16] = autocompleteItems;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t11 = <Form.TemplateInput name={t7} label={t8} placeholder={t9} size="compact" autocompleteItems={t10} />;
    $[18] = t10;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t(_temp3);
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <div className="text-label-2 text-primary">{t12}</div>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== fields || $[28] !== handleRemoveOption || $[29] !== includeOther || $[30] !== questionIndex || $[31] !== t) {
    let t15;
    if ($[33] !== handleRemoveOption || $[34] !== includeOther || $[35] !== questionIndex || $[36] !== t) {
      t15 = (field, index_0) => {
        const minOptions_0 = includeOther ? 0 : 1;
        const canRemove = index_0 > minOptions_0;
        return <div key={field.id} className="flex items-center gap-2"><Form.Input name={`questions.${questionIndex}.options.${index_0}.label`} placeholder={t(_temp4, {
            index: index_0 + 1
          })} size="compact" rules={{
            required: t(_temp5)
          }} />{canRemove && <IconButton icon={IcoClose24} onClick={() => handleRemoveOption(index_0)} aria-label={t(_temp6)} />}</div>;
      };
      $[33] = handleRemoveOption;
      $[34] = includeOther;
      $[35] = questionIndex;
      $[36] = t;
      $[37] = t15;
    } else {
      t15 = $[37];
    }
    t14 = fields.map(t15);
    $[27] = fields;
    $[28] = handleRemoveOption;
    $[29] = includeOther;
    $[30] = questionIndex;
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[38] !== fields.length || $[39] !== includeOther || $[40] !== questionIndex || $[41] !== setValue || $[42] !== t) {
    t15 = includeOther && <div className="flex items-center gap-2"><TextInput disabled={true} value={t(_temp7)} aria-label={t(_temp8)} placeholder={t(_temp9)} size="compact" containerClassName="flex-1" />{fields.length > 0 && <IconButton icon={IcoClose24} onClick={() => setValue(`questions.${questionIndex}.includeOther`, false)} aria-label={t(_temp10)} />}</div>;
    $[38] = fields.length;
    $[39] = includeOther;
    $[40] = questionIndex;
    $[41] = setValue;
    $[42] = t;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t14 || $[45] !== t15) {
    t16 = <div className="flex flex-col gap-2">{t14}{t15}</div>;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== append || $[48] !== fields.length) {
    t17 = () => append({
      value: `option-${fields.length + 1}`,
      label: ""
    });
    $[47] = append;
    $[48] = fields.length;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  let t18;
  if ($[50] !== t) {
    t18 = t(_temp11);
    $[50] = t;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== t17 || $[53] !== t18) {
    t19 = <div className="mt-2"><LinkButton iconComponent={IcoPlusSmall16} iconPosition="left" variant="label-2" onClick={t17}>{t18}</LinkButton></div>;
    $[52] = t17;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t13 || $[56] !== t16 || $[57] !== t19) {
    t20 = <div className="flex flex-col gap-2">{t13}{t16}{t19}</div>;
    $[55] = t13;
    $[56] = t16;
    $[57] = t19;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  const t21 = `questions.${questionIndex}.placeholder`;
  let t22;
  if ($[59] !== t) {
    t22 = t(_temp12);
    $[59] = t;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== t) {
    t23 = t(_temp13);
    $[61] = t;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== t21 || $[64] !== t22 || $[65] !== t23) {
    t24 = <Form.Input name={t21} label={t22} placeholder={t23} size="compact" />;
    $[63] = t21;
    $[64] = t22;
    $[65] = t23;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  let t25;
  if ($[67] !== t) {
    t25 = t(_temp14);
    $[67] = t;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== t) {
    t26 = t(_temp15);
    $[69] = t;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== t) {
    t27 = t(_temp16);
    $[71] = t;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t27) {
    t28 = {
      text: t27
    };
    $[73] = t27;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  let t29;
  if ($[75] !== questionIndex || $[76] !== t25 || $[77] !== t26 || $[78] !== t28) {
    t29 = <DataIdentifierField questionIndex={questionIndex} label={t25} placeholder={t26} tooltip={t28} />;
    $[75] = questionIndex;
    $[76] = t25;
    $[77] = t26;
    $[78] = t28;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  const t30 = `questions.${questionIndex}.includeOther`;
  let t31;
  if ($[80] !== t) {
    t31 = t(_temp17);
    $[80] = t;
    $[81] = t31;
  } else {
    t31 = $[81];
  }
  let t32;
  if ($[82] !== t30 || $[83] !== t31) {
    t32 = <Form.Toggle name={t30} label={t31} size="compact" />;
    $[82] = t30;
    $[83] = t31;
    $[84] = t32;
  } else {
    t32 = $[84];
  }
  const t33 = `questions.${questionIndex}.required`;
  let t34;
  if ($[85] !== t) {
    t34 = t(_temp18);
    $[85] = t;
    $[86] = t34;
  } else {
    t34 = $[86];
  }
  let t35;
  if ($[87] !== t33 || $[88] !== t34) {
    t35 = <Form.Toggle name={t33} label={t34} size="compact" />;
    $[87] = t33;
    $[88] = t34;
    $[89] = t35;
  } else {
    t35 = $[89];
  }
  let t36;
  if ($[90] !== t11 || $[91] !== t20 || $[92] !== t24 || $[93] !== t29 || $[94] !== t32 || $[95] !== t35) {
    t36 = <div className="flex flex-col gap-6">{t11}{t20}{t24}{t29}{t32}{t35}</div>;
    $[90] = t11;
    $[91] = t20;
    $[92] = t24;
    $[93] = t29;
    $[94] = t32;
    $[95] = t35;
    $[96] = t36;
  } else {
    t36 = $[96];
  }
  return t36;
};
export default DropdownForm;
function _temp($) {
  return $.form.label;
}
function _temp2($_0) {
  return $_0.form.labelPlaceholder;
}
function _temp3($_1) {
  return $_1.form.options;
}
function _temp4($_2) {
  return $_2.form.optionPlaceholder;
}
function _temp5($_3) {
  return $_3.form.optionRequired;
}
function _temp6($_4) {
  return $_4.form.removeOption;
}
function _temp7($_5) {
  return $_5.form.otherOption;
}
function _temp8($_6) {
  return $_6.form.otherOption;
}
function _temp9($_7) {
  return $_7.form.otherOption;
}
function _temp10($_8) {
  return $_8.form.removeOption;
}
function _temp11($_9) {
  return $_9.form.addOption;
}
function _temp12($_10) {
  return $_10.form.placeholder;
}
function _temp13($_11) {
  return $_11.form.placeholderPlaceholder;
}
function _temp14($_12) {
  return $_12.form.dataIdentifier;
}
function _temp15($_13) {
  return $_13.form.dataIdentifierPlaceholder;
}
function _temp16($_14) {
  return $_14.form.dataIdentifierTooltip;
}
function _temp17($_15) {
  return $_15.form.includeOtherOption;
}
function _temp18($_16) {
  return $_16.form.required;
}